module.exports = __webpack_public_path__ + "img/MA.6c4bd09c.svg";